export const confirmSmsCode = (payload: { phone: string; code: number }) => ({
    type: '@saga/CONFIRM_SMSCODE',
    payload,
});
